<template>
  <span class="views">
    <a-dropdown size="small">
      <a class="ant-dropdown-link" @click="e => e.preventDefault()">
        <span style="color: #8c95a8"><a-icon type="eye" /> 视图 </span> {{ currentView.name || '所有的' }} <a-icon type="down" />
      </a>
      <a-menu slot="overlay">
        <a-menu-item-group key="public">
          <template slot="title"> 系统视图 </template>
          <a-menu-item v-for="item in publicViews" :key="item.id">
            <a @click="onView(item)">{{ item.name }}</a>
          </a-menu-item>
        </a-menu-item-group>
        <a-menu-item-group key="private">
          <template slot="title"> 个人视图 </template>
          <a-menu-item v-for="item in privateViews" :key="item.id">
            <a @click="onView(item)">{{ item.name }}</a>
          </a-menu-item>
        </a-menu-item-group>
        <a-menu-item key="2">
          <a @click="onEdit"><a-icon type="setting" /> 配置个人视图</a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <ticket-view-modal :display="display" :data-source="privateViews" :show-tag-list="showTagList" @close="close" />
  </span>
</template>
<script>
import { viewList } from '@/api/project/view';
import TicketViewModal from '@/pages/event/components/TicketViewModal';
export default {
  components: { TicketViewModal },
  props: {
    showTagList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      projectId: parseInt(this.$route.params.project_id) || 0,
      publicViews: [],
      privateViews: [],
      currentView: {
        id: 0,
        name: '所有的'
      },
      display: false
    };
  },
  created() {
    this.getViewList();
  },
  methods: {
    getViewList() {
      viewList({ project_id: this.projectId, category: 'ticket' }).then(res => {
        this.publicViews = [
          {
            id: 0,
            name: '所有的',
            params: {}
          },
          ...res.data.public
        ];
        this.privateViews = res.data.private;
        const defaultPrivateView = this.privateViews.find(view => view.is_default === 1);
        if (defaultPrivateView) {
          this.currentView = defaultPrivateView;
          this.$emit('setFilter', this.currentView.params);
        } else {
          this.$emit('setFilter', { start_time: null, end_time: null, about: 'all' });
        }
      });
    },
    onView(view) {
      this.currentView = view;
      if (!view.params.about) {
        view.params = { ...view.params, about: 'all' };
      }
      this.$emit('setFilter', view.params);
    },
    onEdit() {
      this.display = true;
    },
    resetView() {
      this.currentView = {
        id: 0,
        name: '所有的',
        params: {
          about: 'all'
        }
      };
    },
    close() {
      this.display = false;
      this.getViewList();
      this.$emit('setFilter', this.currentView.params);
    }
  }
};
</script>
  <style lang="less" scoped>
  /deep/.ant-select-selection {
    width: auto;
    border: 0;
    display: inline-block;
  }

  /deep/.ant-select-selection:focus {
    border: 0;
  }
  .views {
    line-height: 32px;
    float: left;
  }
  </style>

